import React, { useState } from 'react';

const paragraphs = [
  {
    title: 'Why Choose Indian Ceramic: A Trusted Tiles Manufacturer Brand',
    body:
      'Indian Ceramic is based in Morbi - the ceramic capital of India - and supplies premium vitrified tiles and bathware across India and global markets. Our manufacturing units are equipped with cutting-edge technology, producing tiles in a wide range of finishes, sizes, and surfaces to suit every commercial and residential space.',
  },
  {
    title: 'Innovative Tiles Designs for Every Interior',
    body:
      'Every space tells a story, and design is what brings that to life. Our innovative collection of tiles and bathware is crafted to inspire, reflecting personality and elegance. We thoughtfully blend patterns, textures, and surfaces into the interiors and exteriors of residential and commercial spaces.',
  },
  {
    title: 'Premium Vitrified Tiles for Modern Homes & Commercial Spaces',
    body:
      'Crafted with advanced technology for premium style, durability, and enhanced performance, our tiles offer stain resistance, superior strength, low water absorption, and surfaces engineered to last for decades in high-traffic public spaces, hotels, offices, and retail environments.',
  },
  {
    title: 'Tiles that Blend Sustainability and Strength',
    body:
      'Indian Ceramic stands out for scratch and stain resistance, durability, easy cleaning, and impact resistance that brings elegance and functionality together. The low porosity of our tiles ensures near-zero water absorption and long-lasting beauty with very little maintenance.',
  },
];

export default function WhyChoose() {
  const [expanded, setExpanded] = useState(false);
  return (
    <section className="w-full bg-[#fafaf7] py-20 px-6 md:px-10 border-t border-neutral-200">
      <div className="max-w-5xl mx-auto">
        <div className={`relative ${expanded ? '' : 'max-h-72 overflow-hidden'}`}>
          {paragraphs.map((p, i) => (
            <div key={i} className="mb-8">
              <h3 className="serif text-2xl md:text-3xl font-light text-[#1a1a1a] mb-3">{p.title}</h3>
              <p className="text-[14.5px] leading-relaxed text-[#555] font-light">{p.body}</p>
            </div>
          ))}
          {!expanded && (
            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[#fafaf7] to-transparent pointer-events-none" />
          )}
        </div>
        <div className="flex items-center justify-between mt-6">
          <button onClick={() => setExpanded((e) => !e)} className="text-[11px] tracking-[0.3em] uppercase text-[#7a1a2a] hover:underline">
            {expanded ? 'Show Less' : 'Show More'}
          </button>
          <a href="#" className="bg-[#7a1a2a] hover:bg-[#5a1220] text-white text-[11px] tracking-[0.25em] uppercase px-6 py-3 transition-colors">Enquire Now</a>
        </div>
      </div>
    </section>
  );
}
